<div class="wrapper">
  <section id="area-breadcrumb" class="area-top">
    <div class="container">
      <nav class="breadcrumb">
        <ul>
          <li><a href="/"><strong>Home</strong></a></li>
          <span><i class="fas fa-chevron-right"></i></span>
          <li>Quem Somos</li>
        </ul>
      </nav>
    </div>
  </section>

  <section id="a-montreal">
    <div class="container">
      <div class="columns">
        <div class="area-texto column is-offset-1 is-10">
          <img class="icon-montreal" style="padding-bottom: 25px;" src="assets/img/logo-a-montreal.png" />
          <h1 class="title">Quem somos</h1>
          <div class="menu-right" *ngIf="!isMobile">

            <ul class="nav-page">
              <li><a (click)="scroll('target_nossa_historia')">Nossa História</a></li>
              <li><a (click)="scroll('target_diretoria')">Diretoria</a></li>
              <li><a (click)="scroll('target_conselho')">Conselho</a></li>
              <li><a (click)="scroll('target_administracao')">Administração</a></li>
              <li><a (click)="scroll('target_investidores')">Investidores</a></li>
            </ul>

          </div>
<!--          <p>-->
<!--            Os benefícios de um clube de hospedagem e os serviços de uma agência de viagem, facilitando e simplificando-->
<!--            <br>-->
<!--            suas viagens no Brasil e no exterior.-->
<!--          </p>-->
          <p>
            Há 37 anos no mercado de turismo, a Montreal busca sempre trazer novas experiências em hospedagens incríveis no Brasil e no exterior.
          </p>

          <h4 id='target_nossa_historia'><i class="fas fa-clock"></i>Nossa história</h4>

          <p>
            Apostando na capacidade de enfrentar desafios, em dezembro de 1986 um grupo de visionários decidiu criar
            uma pequena empresa de representação comercial na cidade de Brasília-DF. Pouco mais de 20 anos depois,
            esse empreendimento tornou-se uma das maiores empresas no segmento de Clubes de Hospedagem e um importante
            grupo de turismo do Brasil.
          </p>
          <br>
          <p>
            Na última década transformou-se em uma Sociedade Anônima, redesenhou sua marca e identidade visual,
            reformulou seus canais de atendimento, marcou presença no ambiente digital, ampliou e modernizou sua sede,
            investiu na melhoria de suas operações, na profissionalização de seus Gestores e no desenvolvimento de toda
            sua equipe de profissionais, composta de mais de 200 colaboradores.
          </p>
          <br>
          <p>
            Ao longo dos 37 anos de sua trajetória, a Montreal sempre atuou direta ou indiretamente nas atividades de
            serviços ligados ao turismo. O seu Clube de Hospedagem, em pleno funcionamento desde 1994, já ajudou a
            transformar o sonho de viajar numa experiência única para milhares de brasileiros, que escolheram abraçar
            essa oportunidade e conhecer novos lugares, costumes e pessoas, no Brasil e no exterior, sempre hospedados
            em bons hotéis, com economia e praticidade.
          </p>

          <p style="margin-bottom: -20px">
            <strong>
              Toda conduta praticada em nome do Grupo Montreal é pautada em nossa Missão,
              <br>
              Visão e Valores: pilares da nossa cultura.
            </strong>
          </p>

          <div style="padding-left: 20px;" >
            <h5 id='target_missao'>Missão</h5>
            <p id="target_missao_text">Inspirar pessoas a viverem experiências únicas.</p>
            <h5 id='target_visao'>Visão</h5>
            <p id="target_visao_text">Ser a empresa de turismo e lazer que proporciona experiências incríveis.</p>
            <h5 id='target_valores'>Valores</h5>
            <p id="target_valores_text">
              Foco nas pessoas.<br>
              Autonomia com responsabilidade e ética.<br>
              Inovação e aprendizagem contínua.<br>
              Dedicação à satisfação dos clientes.<br>
              Comunicação e transparência.
            </p>
          </div>

<!--          <h5 id='target_diretoria'>Diretoria</h5>-->

<!--          <div class="area-team">-->
<!--            <div class="equipe text-center equipe-plus">-->
<!--                  <img class="img-team" src="assets/img/fabiana-castro.png" alt="montreal-viagens-imagem-fabiana-castro">-->
<!--                  <p><small>Diretora Presidente</small></p>-->
<!--                  <p style="padding-bottom: 7%">Fabiana S. Bastos de Castro</p>-->
<!--                  &lt;!&ndash;              <p>&ndash;&gt;-->
<!--                  &lt;!&ndash;                <i>&ndash;&gt;-->
<!--                  &lt;!&ndash;                  ”A Montreal tem interesse genuíno pelas pessoas. A percepção de nossos colaboradores, parceiros e clientes é algo&ndash;&gt;-->
<!--                  &lt;!&ndash;                  muito valioso para nós. Uma de nossas prioridades é melhorar a experiência das pessoas com nossa marca.”&ndash;&gt;-->
<!--                  &lt;!&ndash;                </i>&ndash;&gt;-->
<!--                  &lt;!&ndash;              </p>&ndash;&gt;-->
<!--              </div>-->
<!--            <div class="equipe text-center equipe-plus">-->
<!--              <img class="img-team" src="assets/img/alexandre-batista.png" alt="montreal-viagens-imagem-alexandre-batista">-->
<!--              <p><small>Diretor Comercial</small></p>-->
<!--              <p style="padding-bottom: 7%">Alexandre Heitor Ribeiro Batista</p>-->
<!--&lt;!&ndash;              <p>&ndash;&gt;-->
<!--&lt;!&ndash;                <i>&ndash;&gt;-->
<!--&lt;!&ndash;                  ”A Montreal tem interesse genuíno pelas pessoas. A percepção de nossos colaboradores, parceiros e clientes é algo&ndash;&gt;-->
<!--&lt;!&ndash;                  muito valioso para nós. Uma de nossas prioridades é melhorar a experiência das pessoas com nossa marca.”&ndash;&gt;-->
<!--&lt;!&ndash;                </i>&ndash;&gt;-->
<!--&lt;!&ndash;              </p>&ndash;&gt;-->
<!--            </div>-->
<!--            <div class="equipe text-center equipe-plus">-->
<!--              <img class="img-team" src="assets/img/jose-ribamar-2.png" alt="montreal-viagens-imagem-jose-ribamar">-->
<!--              <p><small>Diretor Governança e Compliance</small></p>-->
<!--              <p style="padding-bottom: 7%">José de Ribamar Silva Santos</p>-->
<!--&lt;!&ndash;              <p>&ndash;&gt;-->
<!--&lt;!&ndash;                <i>&ndash;&gt;-->
<!--&lt;!&ndash;                  ”A Montreal tem interesse genuíno pelas pessoas. A percepção de nossos colaboradores, parceiros e clientes é algo&ndash;&gt;-->
<!--&lt;!&ndash;                  muito valioso para nós. Uma de nossas prioridades é melhorar a experiência das pessoas com nossa marca.”&ndash;&gt;-->
<!--&lt;!&ndash;                </i>&ndash;&gt;-->
<!--&lt;!&ndash;              </p>&ndash;&gt;-->
<!--            </div>-->
<!--          </div>-->

<!--          <h5 id='target_conselho'>Conselho de Administração</h5>-->
<!--          <div class="area-team">-->
<!--            <div class="equipe text-center">-->
<!--              <img class="img-team" src="assets/img/romeu-ambrosio.png" alt="montreal-viagens-imagem-romeu-ambrosio">-->
<!--              <p><small>Presidente</small></p>-->
<!--              <p>Romeu Ambrosío</p>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="conselho-montreal">-->
<!--            <div class="area-conselho">-->
<!--              <div>-->
<!--                <p>-->
<!--                  <strong class="cargo">Vice-Presidente</strong><br>-->
<!--                </p>-->
<!--                <img class="img-team conselho" src="assets/img/matheus-carlos-de-andrade.png" alt="montreal-viagens-imagem-matheus-andrade">-->
<!--                <p class="cargo-descricao">Matheus Carlos de Andrade</p>-->
<!--              </div>-->
<!--              <p>-->
<!--                <strong class="cargo">Conselheiros</strong><br>-->
<!--              </p>-->
<!--              <div>-->
<!--                <img class="img-team conselho" src="assets/img/patricia-donida-osorio.png" alt="montreal-viagens-imagem-alexandre-donida-osorio">-->
<!--                <p class="cargo-descricao">Patrícia Donida Osório</p>-->
<!--              </div>-->
<!--              <br>-->
<!--              <div>-->
<!--                <img class="img-team conselho" src="assets/img/jose-ribamar-conselho.png" alt="montreal-viagens-imagem-jose-ribamar-conselho">-->
<!--                <p class="cargo-descricao">José de Ribamar da Silva Santos</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="area-conselho conselho-baixo">-->
<!--              <div class="secundaria">-->
<!--                <img class="img-team conselho" src="assets/img/raphael-rebello.png" alt="montreal-viagens-imagem-raphael-rebello">-->
<!--                <p class="cargo-descricao">Raphael Villar de Queiroz de Castro Rebello</p>-->
<!--              </div>-->
<!--              <div>-->
<!--                <img class="img-team conselho" src="assets/img/helton-carvalhedo.png" alt="montreal-viagens-imagem-helton-carvalhedo">-->
<!--                <p class="cargo-descricao">Helton Prudente Carvalhedo</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <h5  id='target_administracao'>Administração</h5>-->

<!--          <div class="area-team">-->
<!--            <div class="equipe text-center">-->
<!--              <img class="img-team" src="assets/img/fabiana-castro.png" alt="montreal-viagens-imagem-fabiana-castro">-->
<!--              <p><small>COO (Chief Operating Officer)</small></p>-->
<!--              <p>Fabiana Castro</p>-->
<!--              <p>-->
<!--                <i>-->
<!--                  "Minha missão é preparar a empresa para novos desafios e eliminar qualquer tipo de barreira no processo-->
<!--                  de comunicação, trazendo inovação e focando no cuidado com as pessoas e os clientes."-->
<!--                </i>-->
<!--              </p>-->
<!--            </div>-->
<!--&lt;!&ndash;            <div class="equipe text-center">&ndash;&gt;-->
<!--&lt;!&ndash;              <img class="img-team" src="assets/img/flazico-castro.png">&ndash;&gt;-->
<!--&lt;!&ndash;              <p><small>Diretor de Finanças e Inovação</small></p>&ndash;&gt;-->
<!--&lt;!&ndash;              <p>Flazico Castro</p>&ndash;&gt;-->
<!--&lt;!&ndash;              <p><i>Responsável por dar suporte à companhia nos aspectos financeiros e administrativos, primando pela&ndash;&gt;-->
<!--&lt;!&ndash;                  estabilidade e continuidade financeira.</i></p>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--          </div>-->
<!--            <div class="communicated">-->
<!--                    <a [href]="'assets/pdf/CCF_000011.pdf' | urlPipe" target="_blank"-->
<!--                       class="btn-verde communicated__button">COMUNICADO AO MERCADO </a>-->
<!--            </div>-->

          <h5 id='target_investidores'>Investidores</h5>
          <p class="acesse-area">
            Acesse a área de
            <br *ngIf="!isMobile">
            <a target="_blank" href="https://investidores.viagensmontreal.com/login">Relacionamento com
              Investidores</a>
          </p>
          <img class="montreal-investimentos" src="assets/img/montreal-investimentos.png" alt="montreal-viagens-logo-montreal-investimentos">
        </div>
      </div>
    </div>
  </section>

  <app-new-footer></app-new-footer>
</div>
